import React from "react";
import {
  ArrowBack,
  ArrowDownward,
  ArrowForward,
  ArrowUpward,
} from "@mui/icons-material";
import { Box, Grid, Button, IconButton } from "@mui/material";
import PkCommonCard from "../../../components/common/PkCommonCard";
import useInstagramGet from "../../../hooks/useInstagramGet/useInstagramGet";
import { getLayoutView } from "../../../components/layout/getLayoutView";
import { getLayoutText } from "../../../components/layout/getLayoutText";
import useInstagramGetMedia from "../../../hooks/useInstagramGet/useInstagramGetMedia";
const Proof = () => {
  const [slot, slotSet] = React.useState(0);
  const [open, openSet] = React.useState(false);
  const { fetch, error } = []; // useInstagramGet();
  const handleClick = (i) => slotSet(Math.max(Math.min(i, 2), 0));
  return (
    <Box
      sx={(theme) => ({
        ...{
          p: `6rem 12%`,
          display: "flex",
          backgroundRepeat: "no-repeat",
          backgroundSize: `100% 70%, 100%`,
          backgroundColor: `white`,
        },
      })}
    >
      <Grid container>
        <Grid
          data-aos="zoom-in-down"
          data-aos-offset="300"
          item
          xs={12}
          lg={12}
        >
          {getLayoutView(
            <>
              <span style={{ fontFamily: "Lato-Bold" }}>
                PERSPECTIVE
              </span>{" "}
              IS EVERYTHING
            </>,
            [
              getLayoutText(
                <>
                  IT'S TIME TO <span>SHARE YOUR STORY</span> WITH THE LIKE
                  MINDED, THOSE WHO WANT TO <span>EXPERIENCE</span> IT{" "}
                  <span>INTERACTIVELY</span> - YOUR WAY
                </>,
                {
                  fontSize: "1.25rem",
                  fontFamily: "Lato-Regular",
                  lineHeight: 2.25,
                  "& span": {
                    fontFamily: "Lato-Bold",
                    color: (theme) => theme.palette.grey[700],
                  },
                }
              ),
            ],
            [12],
            {
              p: 0,
              textAlign: `center`,
              backgroundColor: `transparent`,
              "& .MuiTypography-root:not(.MuiTypography-caption)": {
                color: (theme) => theme.palette.grey[700],
              },
            }
          )}
          <Box
            sx={{
              pt: 5,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Button
              sx={{ maxWidth: "300px", m: `auto` }}
              variant="contained"
              href={`/developers`}
            >
              CONTROL THE NARRATIVE
            </Button>
          </Box>
        </Grid>
        {/* <Grid
          data-aos="zoom-in-up"
          data-aos-offset="400"
          item
          xs={12}
          lg={12}
          sx={{
            p: `5rem 0 0`,
            display: { xs: "block", lg: "flex" },
            alignItems: `center`,
            justifyContent: "center",
            "& .MuiButtonBase-root": {
              backgroundColor: `#eeeeee`,
            },
          }}
        >
          {((sx = { fontSize: "large", color: "primary" }) => (
            <>
              <Box sx={{ p: 2, textAlign: "center" }}>
                <IconButton onClick={() => handleClick(slot - 1)}>
                  <ArrowUpward
                    {...sx}
                    sx={{ display: { xs: "block", lg: "none" } }}
                  />
                  <ArrowBack
                    {...sx}
                    sx={{ display: { xs: "none", lg: "block" } }}
                  />
                </IconButton>
              </Box>
              <Grid container rowSpacing={4} sx={{ justifyContent: `center` }}>
                {(() => {
                  const list = [
                    ...(fetch ? fetch : []),
                    ...Array(15).fill({ name: "1", media_url: "" }),
                  ].slice(0, 15);
                  return list.slice(slot * 5, slot * 5 + 5).map((s, i) => (
                    <Grid
                      key={`${s.id}:proof${i}`}
                      item
                      xs={12}
                      sm={4}
                      md={3}
                      lg={2}
                      sx={{ "& .MuiPaper-root": { m: `auto` } }}
                    >
                      <PkCommonCard {...s} />
                    </Grid>
                  ));
                })()}
              </Grid>
              <Box sx={{ p: 2, textAlign: "center" }}>
                <IconButton onClick={() => handleClick(slot + 1)}>
                  <ArrowDownward
                    {...sx}
                    sx={{ display: { xs: "block", lg: "none" } }}
                  />
                  <ArrowForward
                    {...sx}
                    sx={{ display: { xs: "none", lg: "block" } }}
                  />
                </IconButton>
              </Box>
            </>
          ))()}
        </Grid> */}
      </Grid>
    </Box>
  );
};
export default Proof;
